<template>
    <div class="flex">
        <span class="iconfont icon-houzhenzhongqz18"></span>
        <span class="ml10">{{showText}}</span>
    </div>
</template>

<script>
  import {timeFormat} from "../../../../common/lib/utils";

  export default {
    name: "daping-timer",
    data() {
      return {
        timer: null,
        time: new Date().getTime()
      }
    },
    computed: {
      showText() {
        return timeFormat(this.time, '%Y-%m-%d %H:%M:%S');
      }
    },
    created() {
      this.djs();
    },
    beforeDestroy() {
      this.clear();
    },
    methods: {
      clear() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      },
      djs() {
        this.clear();
        this.timer = setTimeout(() => {
          this.time += 1000;
          this.djs();
        }, 1000)
      }
    },
  }
</script>

<style scoped>

</style>
